import React from 'react';

const PARTNERS_LOGO =
  'https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/5thrhxjv_pel%20instrumental.png';

const PartnersStrip = () => {
  return (
    <section
      data-testid="partners-strip"
      className="relative py-8 md:py-10 bg-black border-y border-white/5 overflow-hidden"
    >
      <div className="max-w-6xl mx-auto px-4 mb-5">
        <p className="text-center text-[11px] md:text-xs tracking-[0.3em] uppercase text-gray-500 font-semibold">
          Parcerias Oficiais WING Academy
        </p>
      </div>

      <div className="relative">
        {/* edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-black to-transparent z-10"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-black to-transparent z-10"></div>

        {/* Marquee with the official logos image duplicated for seamless loop */}
        <div className="marquee-track items-center">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className="flex-shrink-0 h-24 md:h-32 overflow-hidden flex items-center px-4 md:px-8"
            >
              <img
                src={PARTNERS_LOGO}
                alt="Parceiros oficiais: WING Academy Brasil, Behringer, ProShows, WING Personal Mixing Console"
                className="h-[340px] md:h-[460px] w-auto max-w-none select-none opacity-95 hover:opacity-100 transition-opacity"
                draggable={false}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersStrip;
